import {
  TOrderSettingsTabKey,
} from '@/page/orders/order-settings.ts';

const tabs: Record<TOrderSettingsTabKey, string> = {
  attributes: 'Atribúty',
  tableView: 'Prehľadová tabuľka',
};
export default {
  tabs,
};
